import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'templated-dialog',
    templateUrl: './templated-dialog.component.html',
    styleUrls: ['./templated-dialog.component.scss'],
    standalone: false
})
export class TemplatedDialogComponent {
    checked = true;
    textareaValue: string;

    constructor(
        public dialogRef: MatDialogRef<TemplatedDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: TemplatedDialogConfig
    ) {
        if (this.data?.checked !== undefined) {
            this.checked = this.data.checked;
        }
    }

    confirmDialog() {
        this.dialogRef.close({
            checked: this.checked,
            result: true,
            textareaValue: this.textareaValue
        });
    }

    checkTextarea() {
        if (this.data.showTextareaIfNotChecked && this.checked) {
            this.textareaValue = null;
        }
    }

    closeDialog() {
        this.dialogRef.close();
    }
}

export interface TemplatedDialogResult {
    checked?: boolean;
    result?: boolean;
    textareaValue?: string;
}

export interface TemplatedDialogConfig {
    title?: string;
    header?: string;
    message?: string;
    sureQuestion?: boolean;
    checkbox?: string;
    hideAllButtons?: boolean;
    undraggable?: boolean;
    width?: string;
    confirmText?: string;
    hideCancelButton?: boolean;
    textareaText?: string;
    showTextareaIfNotChecked?: boolean;
    checked?: boolean;
}
